import type { HtmlAttributeValue } from "./types";

const voidTags = new Set(["input", "img"]);

const escapeAttribute = (text: string): string => text.replace(/&/g, "&amp;").replace(/"/g, "&quot;");

/**
 * `<tag a="b" c>children</tag>`. `true` renders a boolean attribute; `false`, `undefined` and `""`
 * are dropped. `children` is already-serialized HTML, never raw text: escape text with
 * `escapeText` first.
 */
export const html = (tag: string, attributes: Record<string, HtmlAttributeValue>, children = ""): string => {
  const serialized = Object.entries(attributes)
    .filter(([, value]) => value !== undefined && value !== false && value !== "")
    .map(([name, value]) => (value === true ? ` ${name}` : ` ${name}="${escapeAttribute(String(value))}"`))
    .join("");
  return voidTags.has(tag) ? `<${tag}${serialized}>` : `<${tag}${serialized}>${children}</${tag}>`;
};
